import { EditOrderRequestData, OrderData } from '../../../api';
import { finishNowEndTimeSeconds } from '../../dialogs/EditOrderDialog/components/dateAndTimePanel/finishNow';

export const buildReleaseTableRequest = (order: OrderData, nowSeconds: number): EditOrderRequestData => {
  const startSeconds = order.time ?? 0;

  return {
    order_id: order.id,
    details: {
      persons: order.persons,
      duration: finishNowEndTimeSeconds(startSeconds, nowSeconds) - startSeconds,
      price: order.price,
      rooms: order.rooms,
      custom_details: order.custom_details,
      chosen_resources: order.chosen_resources,
      resource_option_id: order.resource_option_id,
    },
    date_and_time_details: { date: order.date, time: order.time },
    personal_details: {
      firstname: order.firstname,
      lastname: order.lastname,
      email: order.email,
      phone: order.phone,
      custom_personal_details: order.custom_personal_details,
      alternative_full_name: order.alternative_full_name,
      referral_source: order.referral_source,
    },
    employee_ids: order.employee_ids ?? [],
    comment: order.comment,
    order_page_id: order.order_page_id,
    status: order.status,
    skip_customer_edit_notifications: true,
  };
};
